class Templater {
    install(Vue, options) {
        Vue.mixin({
            init () {
                if (this.$options && this.$options.template instanceof Function) {
                    this.$options.template = this.$options.template(this);
                }
            }
        });
    }
}

module.exports = Templater;



// WEBPACK FOOTER //
// ./resources/assets/javascript/microsistec/templater.js